import { palette } from '$tablet-app/src/app/theme';
import shadows from '$tablet-app/src/app/theme/shadows';
import styled from 'styled-components/native';

const Tile = styled.View`
  background-color: ${palette.white};
  border-radius: 8px;
  ${shadows.small}
`;

export default Tile;
